const text = `
# Partneři:

Bez našich partnerů by se nedařilo šířit všechny skvělé informace do světa. Chcete se stát našim partnerem? Máte zájem nám pomoci jako dobrovolník?

Napište nám na [info@vychovakzivotu.com](mailto:info@vychovakzivotu.com) a rádi Vám sdělíme bližší informace.
`
const sponsors = [
  {
    name: 'IPS',
    logo: require('../resources/sponsors/ips.png'),
    link: 'http://www.socioterapia.sk/',
  },
  {
    name: 'Město Brno',
    logo: require('../resources/sponsors/mestobrno.png'),
    link: 'https://www.brno.cz/',
  },
  {
    name: 'Edutrea',
    logo: require('../resources/sponsors/edutrea.png'),
    link: 'https://www.edutrea.cz/',
  },
  {
    name: 'creedoo',
    logo: require('../resources/sponsors/creedo.png'),
    link: 'http://creedoo.com/',
  },
  {
    name: 'Rosteme pro život',
    logo: require('../resources/sponsors/horme.png'),
    link: '',
  },
  {
    name: 'albi',
    logo: require('../resources/sponsors/albi.png'),
    link: 'https://www.albi.cz/uvod/',
  },
  {
    name: 'Brainy band',
    logo: require('../resources/sponsors/brainy_band.png'),
    link: 'http://www.thebrainyband.sk/',
  },
  {
    name: 'Dlouhá punčocha',
    logo: require('../resources/sponsors/dlouha-puncocha.png'),
    link: 'http://www.dlouhapuncocha.cz/',
  },
  {
    name: 'VIDA',
    logo: require('../resources/sponsors/vida.jpg'),
    link: 'https://vida.cz/',
  },
  {
    name: 'Didaktická hra',
    logo: require('../resources/sponsors/kidedu.png'),
    link: 'http://www.kidedu.cz/',
  },
  {
    name: 'Miniland - internetový obchodík',
    logo: require('../resources/sponsors/miniland.jpg'),
    link: 'https://miniland.sk/',
  },
  {
    name: 'Bruno',
    logo: require('../resources/sponsors/bruno.png'),
    link: 'http://www.brunofamilypark.cz/',
  },
  {
    name: 'PetiteMars',
    logo: require('../resources/sponsors/pettiemars.jpg'),
    link: 'http://www.petiteetmars.com',
  },
  {
    name: 'instea',
    logo: require('../resources/sponsors/instea.png'),
    link: 'http://instea.sk',
  },
  {
    name: 'Detska strava',
    logo: require('../resources/sponsors/detska-strava.png'),
    link: 'https://detskastrava.eu/',
  },
  {
    name: 'Helen Doron English',
    logo: require('../resources/sponsors/helen-doron.png'),
    link: 'http://helendoron.cz/branch/brno-sever',
  },
]

export default {
  text,
  sponsors,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/sponsors/partners.js